import {createStore, applyMiddleware, compose} from 'redux';
import isEmpty from 'lodash/isEmpty';
import logger from 'redux-logger';
import {routerMiddleware} from 'connected-react-router';
import thunk from 'redux-thunk';
import {persistStore} from 'redux-persist';
import reducer from '../reducers';
import {history, appId, isRedemption} from '../history';
import {BASE_URL_REGEX, APPID_REGEX} from '../configs/constants';

// TODO: related to #35297
// const isDev = process.env.NODE_ENV === 'development';
const isTest = process.env.NODE_ENV === 'test';
const isE2E = process.env.__E2E__;

const initialState = {application: {isRedemption}};

if (!isTest && !isE2E && !isRedemption) {
  const {pathname} = window.location;
  const baseMatches = pathname.match(BASE_URL_REGEX);
  if (isEmpty(baseMatches)) {
    initialState.error = {
      error: 'Incorrect application path',
    };
  }
  const appIdMatches = baseMatches && baseMatches[0].match(APPID_REGEX);
  if (isEmpty(appIdMatches)) {
    initialState.error = {
      error: 'Incorrect application id',
    };
  }
}

const middleware = [
  routerMiddleware(history),
  thunk,
  logger,
];

let enhancer = applyMiddleware(...middleware);

if (window.devToolsExtension) {
  enhancer = compose(
    applyMiddleware(...middleware),
    window.devToolsExtension({trace: true, traceLimit: 25})
  );
}

const _store = createStore(
  reducer,
  initialState,
  enhancer
);
export const persistor = persistStore(_store);
export const store = _store;
export {history, appId};
